import { createActions } from "redux-actions";

export const { addNotificationModal } = createActions('ADD_NOTIFICATION_MODAL');
export const { removeNotificationModal } = createActions('REMOVE_NOTIFICATION_MODAL');



// WEBPACK FOOTER //
// ./src/redux/notificationModalActions.js